import { Typography } from "@mui/material"

import { PropTypes } from "@l2r-front/l2r-proptypes"

import * as Styled from "./LayerIndicator.styled"

export function LayerIndicator(props) {
    const {
        className,
        text,
        title,
    } = props

    if (!text) {
        return <Styled.RoadInfoItemSkeleton className={className} />
    }

    return <Styled.LayerWrapper className={className} id="layer-indicator">
        <Styled.Wrapper>
            <Styled.Icon color="cta-bg/cta-bg-primary" />
            <Typography variant="Small accent">
                {title}
            </Typography>
        </Styled.Wrapper>
        <Styled.LabelWrapper>
            <Typography variant="Regular">
                {text}
            </Typography>
        </Styled.LabelWrapper>
    </Styled.LayerWrapper>
}

LayerIndicator.propTypes = {
    className: PropTypes.string,
    text: PropTypes.string,
}